import axios from 'axios'
import qs from 'qs'

let config = {
    timeout: 20000,
    baseURL: 'https://culture.aqitai.com',
    headers:{
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
        'Authorization': ''
    },
    responseType: "json",
    transformRequest: [data => qs.stringify(data)]
};

export default {
    get (option) {
        config.headers['Authorization'] = 'Bearer ' + (localStorage.getItem('token'))
        let { url, data = {} } = option
        return new Promise((resolve, reject)=>{
            axios.get(url,{params: data, ...config}).then(res=>{
                let obj = {
                    code: res.data.code,
                    data: res.data.data
                }
                resolve(obj);
            }).catch(error=>{
                if (error.message === 'Request failed with status code 401') {
                    Vm.$router.push({path:'/login',query:{lib_type:sessionStorage.getItem('gcm')}})
                    document.title = ''
                }
                reject({message: '页面溜走了，请稍后重试', error: error});
            });
        });
    },

    post (option) {
        config.headers['Authorization'] = 'Bearer ' + (localStorage.getItem('token'))
        let { url, data = {} } = option
        return new Promise((resolve, reject) => {
            axios.post(url, data, { ...config }).then(res=>{
                resolve(res.data);
            }).catch(error=>{
                if (error.message === 'Request failed with status code 401') {
                    Vm.$router.push({path:'/login',query:{lib_type:sessionStorage.getItem('gcm')}})
                    document.title = ''
                }
                reject({message: '页面溜走了，请稍后重试', error: error});
            });
        })
    },

    put (option) {
        config.headers['Authorization'] = 'Bearer ' + (localStorage.getItem('token'))
        let {url, data = {}}=option;
        return new Promise((resolve, reject) => {
            axios.put(url, data, { ...config }).then(res=>{
                resolve(res.data);
            }).catch(error=>{
                if (error.message === 'Request failed with status code 401') {
                    Vm.$router.push({path:'/login',query:{lib_type:sessionStorage.getItem('gcm')}})
                    document.title = ''
                }
                reject({message: '页面溜走了，请稍后重试', error: error});
            });
        })
    },

    delete (option) {
        config.headers['Authorization'] = 'Bearer ' + (localStorage.getItem('token'))
        let { url, data = {} } = option
        return new Promise((resolve, reject) => {
            axios.delete(url,{data: data, ...config}).then(res=>{
                resolve(res.data);
            }).catch(error=>{
                if (error.message === 'Request failed with status code 401') {
                    Vm.$router.push({path:'/login',query:{lib_type:sessionStorage.getItem('gcm')}})
                    document.title = ''
                }
                reject({message: '页面溜走了，请稍后重试！', error: error});
            });
        })
    }
}
